import { render, staticRenderFns } from "./packForm.vue?vue&type=template&id=29fc0896&scoped=true"
import script from "./packForm.vue?vue&type=script&lang=js"
export * from "./packForm.vue?vue&type=script&lang=js"
import style0 from "./packForm.vue?vue&type=style&index=0&id=29fc0896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fc0896",
  null
  
)

export default component.exports